import '../svg-icon/svg-icon';

import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Icon, Annotation } from './floorplan';

@customElement('floorplan-floor')
export class FloorplanFloor extends LitElement {

    // Props

    @property({ type: String })
    name: string = '';

    @property({ type: String })
    label: string = '';

    @property({ type: Array })
    icons: Icon[] = [];

    @property({ type: Array })
    annotations: Annotation[] = [];

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('Floorplan-floor');
    }

    // Render
    
    render() {
        return html`
            <div class="Floorplan-background">
                <svg aria-hidden="true">
                    <use href="#floorplan--${ this.name }"></use>
                </svg>
            </div>
            <div class="Floorplan-icons">
                ${ this.icons.map((icon) => this.iconTemplate(icon)) }
            </div>
            <div class="Floorplan-annotations">
                ${ this.annotations.map((annotation) => this.annotationTemplate(annotation)) }
            </div>
        `;
    }

    createRenderRoot() { 
        return this;
    }

    iconTemplate(icon: Icon): TemplateResult {
        return html`
            <svg 
                aria-hidden="true" 
                style="left: ${ icon.position[0] }%; top: ${ icon.position[1] }%;">
                <use href="#icon--${ icon.name }"></use>
            </svg>
        `;
    }

    annotationTemplate(annotation: Annotation): TemplateResult {
        return html`
            <span 
                class="Floorplan-annotation"
                aria-hidden="true" 
                style="
                    left: ${ annotation.position[0] }%; 
                    top: ${ annotation.position[1] }%;
                    transform-origin: ${ 0 - annotation.offset[0] }% ${ 0 - annotation.offset[1] }%;
                    transform: translate(${ annotation.offset[0] }%, ${ annotation.offset[1] }%) rotate(${ annotation.rotation }deg)">
                ${ annotation.text }
            </span>
        `;
    }


}